import React from 'react';

function ConfirmationModal({ isOpen, onClose, onConfirm, errorMessage }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                <h2 className="text-xl font-semibold mb-4">Внимание</h2>
                <p className="mb-4">{errorMessage}</p>
                <div className="flex justify-end space-x-4">
                    <button
                        onClick={() => onConfirm()}
                        className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
                    >
                        Всё равно продать!
                    </button>
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                    >
                        Отмена
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmationModal;
